export default "__VITE_ASSET__9f1610e6__"